import React from 'react';
import { Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * UI-070: yellow warning when the patient's assigned nurse / case-manager is
 * marked inactive on the user record (`is_active = 0`). The backend never
 * auto-clears these (Locked Design Decision UD7) — the UI surfaces the
 * problem and the human acts. Pair this with `NurseCasemanagerPickers` so the
 * admin can clear or replace the assignment in the same view.
 */
const StaleAssignmentBanner = ({ roleLabel, staff }) => {
  if (!staff) return null;
  const active = staff.is_active === 1 || staff.is_active === '1' || staff.is_active === true;
  if (active) return null;
  const name = `${staff.first_name || ''} ${staff.last_name || ''}`.trim() || `User #${staff.id}`;
  return (
    <Alert variant="warning" className="py-2 mb-2 fs-11">
      <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
      <strong>{roleLabel} {name} is inactive</strong> — please reassign or clear.
    </Alert>
  );
};

export default StaleAssignmentBanner;
